/**
 * The drag source and folder drop target props for one view's items, as one
 * stable builder (`useItemDrag` + `useFolderDropTarget`). Tiles get it through
 * TileGrid; list rows through DataGrid's `getRowProps`.
 */

import { useCallback } from 'react';
import type { WorkspaceItem } from '@bower/shared';

import { useFolderDropTarget, type FolderDropProps } from './useFolderDropTarget';
import { useItemDrag, type ItemDragProps } from './useItemDrag';

export type ItemDndProps = ItemDragProps & Partial<FolderDropProps>;

/** `folderId` is the open folder (null = the workspace root). */
export function useItemDnd(items: readonly WorkspaceItem[], folderId: string | null) {
  const dragProps = useItemDrag(items);
  const dropProps = useFolderDropTarget(folderId);
  return useCallback(
    (item: WorkspaceItem): ItemDndProps => ({ ...dragProps(item), ...dropProps(item) }),
    [dragProps, dropProps],
  );
}
